module.exports = __webpack_public_path__ + "images/category_lp/common/man_40_2a6eab8461dcf011a46bff28031bc033.png";